// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2[data-v-b07ea0ae] {\n  font-size: 18px;\n}\n.delete-title[data-v-b07ea0ae] {\n  font-size: 1.875rem;\n  color: #003545;\n}\n.v-btn[data-v-b07ea0ae] {\n  vertical-align: top;\n}\n.v-btn.v-btn--depressed[data-v-b07ea0ae] {\n  min-width: 17% !important;\n}\n.notice[data-v-b07ea0ae] {\n  background: #fffbe5;\n}\n.code-wrapper[data-v-b07ea0ae] {\n  position: relative;\n  background: #E8EEF1;\n}\n.code-wrapper .new-tab[data-v-b07ea0ae] {\n  position: absolute;\n  right: 4px;\n}", ""]);
// Exports
module.exports = exports;
